import { ColDef } from "ag-grid-community";

import { Info, RolesCellRenderer } from "./GridFrameworks";

const columnDef: ColDef[] = [
    {
        headerName: "",
        field: "Id",
        cellRenderer: Info,
        width: 65,
        minWidth: 65,
        pinned: "left",
    },
    {
        headerName: "First Name",
        field: "FirstName",
        sortable: true,
        filter: true,
        resizable: true,
        headerStyle: { paddingLeft: "8px" },
        cellStyle: { paddingLeft: "8px" },
    },
    {
        headerName: "Last Name",
        field: "LastName",
        sortable: true,
        resizable: true,
    },
    {
        headerName: "Email",
        field: "Email",
        sortable: true,
        resizable: true,
        flex: 1,
        minWidth: 200,
    },
    {
        headerName: "Roles",
        field: "RoleNames",
        cellRenderer: RolesCellRenderer,
        sortable: true,
        filter: true,
        resizable: true,
        flex: 1,
        minWidth: 180,
    },
    {
        headerName: "Created At",
        field: "CreatedAt",
        sortable: true,
        resizable: true,
        width: 170,
    },
    {
        headerName: "Last Update",
        field: "UpdatedAt",
        sortable: true,
        resizable: true,
        width: 170,
    },
];

export { columnDef };
